

export enum AlertRecipientsType {
	NONE = 'NONE', ALL = 'ALL', SELECTED = 'SELECTED'
}